var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.isShown)?_c('div',{staticClass:"PrivateVideoStream"},[_c('div',{staticClass:"videoOuter"},[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.watchingVideoId,"height":"100%","width":"100%","player-vars":{
          autoplay: 1,
          modestbranding: 1,
          showinfo: 0,
          controls: 0,
          disablekb: 1,
          fs: 0,
          hl: 'nl',
          iv_load_policy: 3,
          rel: 0,
        }},on:{"ended":_vm.finishedVideo,"error":_vm.finishedVideo,"playing":_vm.setVolume}})],1),_c('div',{staticClass:"pane",on:{"click":_vm.startVideo}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }